import React, { useContext } from 'react'
import classnames from 'classnames'
import Split from '../split-line'
import styles from './index.module.less'
import context from '@/components/poizon-fission/context'

const SwitchLanguage = (props: { lang: string; local: string }) => {
  const { lang, local } = props
  const firstUrl = 'https://fast.poizon.com/poizon/detail/'
  const secondUrl = `${lang}/${local}/`

  const goPrivacyPolicy = () => {
    location.href = `${firstUrl}${secondUrl}6036361d099f3a3be36393d7`
  }
  const goUserService = () => {
    location.href = `${firstUrl}${secondUrl}60362c2b9882f7077424bc5d`
  }

  // 英文
  if (lang === 'en') {
    return (
      <>
        I’ve read and I agree POIZON's <span onClick={goPrivacyPolicy}>Privacy Policy</span> and
        <span onClick={goUserService}>User Service Agreement</span>. Your account will be created
        automatically after your first-time login.
      </>
    )
  }
  // 香港繁中/台湾繁中/澳门繁中
  if (['zh-TW', 'zh-TW2', 'zh-MO'].includes(lang)) {
    return (
      <>
        已經閱讀並同意<span onClick={goPrivacyPolicy}>隱私權協議</span>和
        <span onClick={goUserService}>用戶服務協議</span>，首次登錄後即自動註冊賬號。
      </>
    )
  }

  // 日文
  if (lang === 'ja') {
    return (
      <>
        <span onClick={goPrivacyPolicy}>プライバシーポリシー</span>と
        <span onClick={goUserService}>利用規約</span>
        を読んで同意しました、初ログインした後、自動にアカウント登録を行います。
      </>
    )
  }

  // 简体中文// 日文
  if (lang === 'zh') {
    return (
      <>
        已经阅读并同意<span onClick={goPrivacyPolicy}>隐私权协议</span>和
        <span onClick={goUserService}>用户服务协议</span>，首次登录后即自动注册账号。
      </>
    )
  }
  return <></>
}

const Protocols = (props: { checked: boolean; handle: () => void }) => {
  const { checked, handle } = props
  const { lang, local } = useContext(context)

  return (
    <>
      <div className={styles.protocol}>
        <div onClick={handle}>
          <em className={classnames(styles.checkbox, { [styles.checked]: checked })} />
        </div>
        <Split flexible={false} width={4} />
        <div className={styles.link}>
          <SwitchLanguage lang={lang} local={local} />
        </div>
      </div>
    </>
  )
}

export default Protocols
